module.exports = __webpack_public_path__ + "3a1c2a8ce9dc30f3d2810ee373c41424.svg";